import { camelCaseTransformer } from '@sondermind/utilities/tools';
import { BenefitVerificationError } from './benefit-verification-error.interface';
import { BenefitVerificationDemographics } from './benefit-verification-demographics.interface';
import { SuggestedPayer } from './suggested-payer.model';

export class BenefitVerification {
  success: boolean;
  aasm_state: string;
  created_at: Date;
  updated_at: Date;
  id: number;
  poki_dok_response: any;

  // Enhanced BV response properties
  coverage_start_date?: string;
  coverage_end_date?: string;
  coverage_status?: 'active' | 'inactive' | 'unknown' | 'Active' | 'Inactive' | 'Unknown';
  cost_estimate?: number;
  verified?: boolean;
  error?: BenefitVerificationError[] | string[];
  demographic_information?: BenefitVerificationDemographics;
  suggested_payer?: SuggestedPayer;
  failure_reason?: string;
  in_network?: boolean;
  medicaid?: boolean;
  active?: boolean;
  clients_can_add_to_account?: boolean;

  constructor(data: any = {}) {
    this.load_from_json(data);
  }

  static fromJson(json: any): BenefitVerification {
    return new BenefitVerification(json);
  }

  load_from_json(data: any): void {
    this.success = data.success ?? false;
    this.aasm_state = data.aasm_state ?? '';
    this.created_at = data.created_at ? new Date(data.created_at) : new Date();
    this.updated_at = data.updated_at ? new Date(data.updated_at) : new Date();
    this.id = data.id ?? 0;
    this.poki_dok_response = data.poki_dok_response;

    this.coverage_start_date = data.coverage_start_date;
    this.coverage_end_date = data.coverage_end_date;
    this.coverage_status = data.coverage_status;
    this.cost_estimate = data.cost_estimate;
    this.verified = data.verified;
    this.error = data.error;
    this.demographic_information = data.demographic_information;

    this.failure_reason = data.failure_reason;
    this.in_network = data.in_network;
    this.medicaid = data.medicaid;
    this.active = data.active;
    this.clients_can_add_to_account = data.clients_can_add_to_account;
    this.suggested_payer = camelCaseTransformer<SuggestedPayer>(data.suggested_payer);
  }

  /**
   * Get a PokitDok response for you to display, or an empty object
   * if there isn't one (IE, you requested the wrong view).
   */
  get readablePokitDokResponse(): { [key: string]: any; } {
    if (typeof this.poki_dok_response === 'object') {
      return this.poki_dok_response;
    }

    return {};
  }
}
